import React from "react";
import useCallCenterT from "../../../hooks/useCallCenterT";
import CallRecordingPlayer from "../../../components/call-center/CallRecordingPlayer";

const CallHistoryPanel = ({ history }) => {
  const t = useCallCenterT();

  return (
    <div className="rounded-lg border border-slate-200 p-3">
      <div className="text-sm font-semibold text-slate-700">{t("ccCallHistory")}</div>
      <div className="mt-2 max-h-60 overflow-auto text-xs">
        {(history || []).length === 0 ? (
          <div className="text-slate-500">{t("ccNoCallsFound")}</div>
        ) : (
          history.slice(0, 20).map((call) => (
            <div key={call.id} className="mb-2 rounded border border-slate-100 p-2 space-y-2">
              <div className="font-medium text-slate-700">
                {call.direction === "INBOUND" ? t("ccCallDirectionInbound") : t("ccCallDirectionOutbound")}
                {" · "}
                {call.phoneNumber || t("ccEmDash")}
              </div>
              <div className="text-slate-500">
                {call.accountId || t("ccUnknownAccount")} • {call.status}
              </div>
              <CallRecordingPlayer callId={call.id} recordingUrl={call.recordingUrl} />
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default CallHistoryPanel;
